export const getPercentageOrAmount = (amount1, amount2, mode) => {
    if (mode === 'percentage') {
        return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
    } else if (mode === 'amount') {
        return (amount1 * amount2) / 100; // amount2% of amount1
    } else {
        return 'Invalid mode';
    }
}